/*
 * Renneway kurumsal alici kayit formu — urun sayfasindaki giris penceresi ve hesap sayfasi ortak kullanir.
 * Secenekler ve etiketler backend'den gelir (/panel/buyer/api/registration-options), boylece tema,
 * mobil uygulama ve backend dogrulamasi ayni listeyi kullanir.
 *
 *   window.rnwRegister.mount(containerEl)  -> alanlari cizer (Promise)
 *   window.rnwRegister.collect(formEl)     -> API govdesi
 *   window.rnwRegister.markError(formEl, field)
 *   window.rnwRegister.label(key)
 */
(function () {
  'use strict';

  var API_BASE = (window.RENNEWAY_API_BASE || '').replace(/\/+$/, '');
  var optionsPromise = null;
  var OPTS = null;

  // ISO 3166-1 ulke kodlari — adlar tarayicinin Intl.DisplayNames'iyle aktif dilde uretilir
  var COUNTRY_CODES = ('AF AL DZ AD AO AG AR AM AU AT AZ BS BH BD BB BY BE BZ BJ BT BO BA BW BR BN BG BF BI KH CM CA CV CF TD CL CN CO KM CG CD CR CI HR CU CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FJ FI FR GA GM GE DE GH GR GD GT GN GW GY HT HN HK HU IS IN ID IR IQ IE IL IT JM JP JO KZ KE KI KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MR MU MX FM MD MC MN ME MA MZ MM NA NR NP NL NZ NI NE NG MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RO RU RW KN LC VC WS SM ST SA SN RS SC SL SG SK SI SB SO ZA KR SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TM TV UG UA AE GB US UY UZ VU VE VN YE ZM ZW').split(' ');

  function lang() {
    var l = (window.RENNEWAY_I18N && window.RENNEWAY_I18N['common.lang']) || document.documentElement.lang || 'en';
    return String(l).toLowerCase().indexOf('tr') === 0 ? 'tr' : 'en';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function label(key) {
    var l = OPTS && OPTS.labels && OPTS.labels[key];
    return l ? l[lang()] : key;
  }

  function optLabel(o) { return lang() === 'tr' ? o.tr : o.en; }

  function loadOptions() {
    if (!optionsPromise) {
      optionsPromise = fetch(API_BASE + '/panel/buyer/api/registration-options', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { OPTS = j.options; return OPTS; });
    }
    return optionsPromise;
  }

  function countryOptions() {
    var dn = null;
    try { dn = new Intl.DisplayNames([lang() === 'tr' ? 'tr' : 'en'], { type: 'region' }); } catch (e) { /* eski tarayici */ }
    var en = null;
    try { en = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { /* eski tarayici */ }
    return COUNTRY_CODES
      .map(function (c) { return { code: c, name: dn ? dn.of(c) : c, value: en ? en.of(c) : c }; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, lang()); });
  }

  function field(name, labelText, inputHtml, opts) {
    opts = opts || {};
    return '<label class="rnw-reg__field' + (opts.full ? ' rnw-reg__field--full' : '') + '" data-rnw-reg-field="' + name + '"' + (opts.hidden ? ' hidden' : '') + '>' +
      '<span>' + esc(labelText) + (opts.optional ? ' <em>(' + esc(label('optional')) + ')</em>' : '') + '</span>' +
      inputHtml + '</label>';
  }

  function checkboxGroup(name, list) {
    return '<div class="rnw-reg__checks">' + list.map(function (o) {
      return '<label class="rnw-reg__check"><input type="checkbox" name="' + name + '" value="' + esc(o.code) + '"> ' + esc(optLabel(o)) + '</label>';
    }).join('') + '</div>';
  }

  function render(container) {
    var o = OPTS;
    var accountTypeOpts = o.accountTypes.map(function (a) {
      return '<label class="rnw-reg__type"><input type="radio" name="accountType" value="' + a.code + '"' + (a.code === 'tr_company' ? ' checked' : '') + '>' +
        '<span>' + esc(optLabel(a)) + '</span></label>';
    }).join('');

    var countries = countryOptions().filter(function (c) { return c.code !== 'TR'; })
      .map(function (c) { return '<option value="' + esc(c.value) + '">' + esc(c.name) + '</option>'; }).join('');

    var volumeOpts = '<option value="">' + esc(label('select')) + '</option>' + o.annualVolumes.map(function (v) {
      return '<option value="' + v.code + '">' + esc(optLabel(v)) + '</option>';
    }).join('');
    var currencyOpts = o.currencies.map(function (c) { return '<option value="' + c + '">' + c + '</option>'; }).join('');

    container.innerHTML =
      '<p class="rnw-reg__note">' + esc(label('approvalNote')) + '</p>' +

      '<div class="rnw-reg__section">' + esc(label('accountType')) + '</div>' +
      '<div class="rnw-reg__types">' + accountTypeOpts + '</div>' +

      '<div class="rnw-reg__section">' + esc(label('section_company')) + '</div>' +
      '<div class="rnw-reg__grid">' +
        field('country', label('country'), '<select name="country"><option value="">' + esc(label('select')) + '</option>' + countries + '</select>', { hidden: true }) +
        field('companyName', label('companyName'), '<input type="text" name="companyName" maxlength="200" required autocomplete="organization">', { full: true }) +
        field('legalForm', label('legalForm'), '<select name="legalForm"></select>', { optional: true }) +
        field('taxNumber', label('taxNumber_tr_company'), '<input type="text" name="taxNumber" maxlength="30" required>') +
        field('taxOffice', label('taxOffice'), '<input type="text" name="taxOffice" maxlength="120">') +
        field('registrationNumber', label('registrationNumber'), '<input type="text" name="registrationNumber" maxlength="60">', { optional: true }) +
        field('website', label('website'), '<input type="text" name="website" maxlength="200" placeholder="www.">', { optional: true }) +
        field('foundedYear', label('foundedYear'), '<input type="number" name="foundedYear" min="1800" max="2100">', { optional: true }) +
      '</div>' +

      '<div class="rnw-reg__section">' + esc(label('section_contact')) + '</div>' +
      '<div class="rnw-reg__grid">' +
        field('name', label('name'), '<input type="text" name="name" maxlength="120" required autocomplete="name">') +
        field('jobTitle', label('jobTitle'), '<input type="text" name="jobTitle" maxlength="120" required autocomplete="organization-title">') +
        field('phone', label('phone'), '<input type="tel" name="phone" maxlength="40" required autocomplete="tel" placeholder="+90 ...">', { full: true }) +
      '</div>' +

      '<div class="rnw-reg__section">' + esc(label('section_address')) + '</div>' +
      '<div class="rnw-reg__grid">' +
        field('addressLine', label('addressLine'), '<input type="text" name="addressLine" maxlength="300" required autocomplete="street-address">', { full: true }) +
        field('city', label('city'), '<input type="text" name="city" maxlength="80" required autocomplete="address-level2">') +
        field('postalCode', label('postalCode'), '<input type="text" name="postalCode" maxlength="20" autocomplete="postal-code">', { optional: true }) +
      '</div>' +

      '<div class="rnw-reg__section">' + esc(label('section_business')) + '</div>' +
      field('activities', label('activities'), checkboxGroup('activities', o.activities), { full: true, optional: true }) +
      '<div class="rnw-reg__grid">' +
        field('annualVolume', label('annualVolume'), '<select name="annualVolume">' + volumeOpts + '</select>', { optional: true }) +
        field('preferredCurrency', label('preferredCurrency'), '<select name="preferredCurrency">' + currencyOpts + '</select>') +
      '</div>' +
      field('fibers', label('fibers'), checkboxGroup('fibers', o.fibers), { full: true, optional: true }) +

      '<div class="rnw-reg__section">' + esc(label('section_account')) + '</div>' +
      '<div class="rnw-reg__grid">' +
        field('email', label('email'), '<input type="email" name="email" required autocomplete="email">') +
        field('password', label('password'), '<input type="password" name="password" minlength="6" required autocomplete="new-password">') +
      '</div>' +
      '<label class="rnw-reg__consent" data-rnw-reg-field="termsAccepted"><input type="checkbox" name="termsAccepted" required> <span>' + esc(label('termsAccepted')) +
        (OPTS.buyerAgreement ? ' <a href="' + esc(API_BASE + OPTS.buyerAgreement.url) + '" target="_blank" rel="noopener">' + esc(label('readAgreement')) + ' →</a>' : '') +
        '</span></label>' +
      '<label class="rnw-reg__consent"><input type="checkbox" name="marketingConsent"> <span>' + esc(label('marketingConsent')) + '</span></label>';

    var form = container.closest('form');
    var submit = form && form.querySelector('button[type=submit]');
    if (submit) submit.textContent = label('submit');

    container.querySelectorAll('input[name=accountType]').forEach(function (r) {
      r.addEventListener('change', function () { applyType(container); });
    });
    applyType(container);
  }

  // Hesap turune gore alan gorunurlugu, zorunluluk ve etiketler
  function applyType(container) {
    var checked = container.querySelector('input[name=accountType]:checked');
    var type = checked ? checked.value : 'tr_company';
    var show = function (name, on) {
      var el = container.querySelector('[data-rnw-reg-field="' + name + '"]');
      if (el) el.hidden = !on;
      var input = el && el.querySelector('input, select');
      return input;
    };
    var country = show('country', type === 'foreign_company');
    if (country) country.required = type === 'foreign_company';
    var taxOffice = show('taxOffice', type !== 'foreign_company');
    if (taxOffice) taxOffice.required = type !== 'foreign_company';

    var taxLabel = container.querySelector('[data-rnw-reg-field="taxNumber"] > span');
    if (taxLabel) taxLabel.textContent = label('taxNumber_' + type);
    var nameLabel = container.querySelector('[data-rnw-reg-field="companyName"] > span');
    if (nameLabel) nameLabel.textContent = label(type === 'sole_proprietor' ? 'companyName_sole' : 'companyName');

    var legal = container.querySelector('select[name=legalForm]');
    if (legal) {
      var forms = (OPTS.legalForms && OPTS.legalForms[type]) || [];
      legal.innerHTML = '<option value="">' + esc(label('select')) + '</option>' +
        forms.map(function (f) { return '<option value="' + esc(f) + '">' + esc(f) + '</option>'; }).join('');
    }
    var phone = container.querySelector('input[name=phone]');
    if (phone) phone.placeholder = type === 'foreign_company' ? '+44 ...' : '+90 ...';
  }

  function collect(form) {
    var fd = new FormData(form);
    var body = {};
    ['accountType', 'country', 'companyName', 'legalForm', 'taxNumber', 'taxOffice', 'registrationNumber', 'website',
      'foundedYear', 'name', 'jobTitle', 'phone', 'addressLine', 'city', 'postalCode', 'annualVolume',
      'preferredCurrency', 'email', 'password'].forEach(function (k) {
      var v = fd.get(k);
      if (v != null) body[k] = String(v).trim();
    });
    body.activities = fd.getAll('activities');
    body.fibers = fd.getAll('fibers');
    body.termsAccepted = !!fd.get('termsAccepted');
    body.marketingConsent = !!fd.get('marketingConsent');
    body.kvkkConsent = body.termsAccepted;
    body.preferredLanguage = lang();
    return body;
  }

  function markError(form, fieldName) {
    form.querySelectorAll('.rnw-reg__field.is-error, .rnw-reg__consent.is-error').forEach(function (el) { el.classList.remove('is-error'); });
    if (!fieldName) return;
    var el = form.querySelector('[data-rnw-reg-field="' + fieldName + '"]');
    if (!el) return;
    el.classList.add('is-error');
    if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var input = el.querySelector('input, select');
    if (input && input.focus) setTimeout(function () { input.focus(); }, 250);
  }

  function mount(container) {
    if (!container) return Promise.resolve();
    return loadOptions().then(function () { render(container); });
  }

  window.rnwRegister = { mount: mount, collect: collect, markError: markError, label: label, loadOptions: loadOptions };
})();
